import api from './api';

/**
 * Beta Feedback API endpoints
 * For collecting player feedback during beta testing
 */

/**
 * Submit beta feedback
 * @param {object} feedbackData - The feedback data
 * @param {string[]} feedbackData.unit_ranking - Array of unit slugs in order of preference
 * @param {Array<{units: string[], reason: string}>} feedbackData.favorite_combos - Custom combos with reasons
 * @param {number|null} feedbackData.turn_system_rating - 1-5 star rating
 * @param {string|null} feedbackData.liked_most - What they liked most
 * @param {string|null} feedbackData.improvement_suggestions - Suggestions for improvement
 * @returns {Promise<object>} Response data
 */
export const submitBetaFeedback = async (feedbackData) => {
    const response = await api.post('/api/beta-feedback', feedbackData);
    return response.data;
};

export default {
    submitBetaFeedback
};
